import React from 'react';
import Icon from '../../../components/AppIcon';
import { Card, CardHeader, CardTitle, CardContent } from '../../../components/ui/Card';
import Button from '../../../components/ui/Button';

const VacantInventoryWidget = ({ vacantUnits, vacantCount, onViewAll, onViewVacant }) => {
  const displayCount = vacantCount || vacantUnits || 0;

  return (
    <Card shadow="md" className="border border-border">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="flex items-center gap-2">
            <Icon name="Building2" size={20} className="text-primary-500" />
            Vacant Inventory
          </CardTitle>
          <Button
            variant="ghost"
            size="sm"
            onClick={onViewAll}
            iconName="ArrowRight"
            iconPosition="right"
          >
            View All
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="text-center py-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-warning-100 mb-4">
            <Icon name="AlertCircle" size={32} className="text-warning-600" />
          </div>
          <h3 className="text-h1 font-heading font-bold text-foreground mb-2">
            {displayCount}
          </h3>
          <p className="text-body text-muted-foreground mb-6">
            Units currently vacant
          </p>
          <Button
            variant="primary"
            onClick={onViewVacant}
            iconName="Eye"
            iconPosition="left"
          >
            View Vacant Units
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default VacantInventoryWidget;